import React, { Fragment } from "react";
import Moment from "react-moment";

import RedLogo from "../Mentors/RedLogo";

const ActiveSubscriptionInfo = ({
  subscriber,
  setshowActiveSubscription,
  profile: { avatar, firstname, lastname, jobtitle, location },
}) => {
  return (
    <Fragment>
      <div className="subscription-overlay">
        <div className="subscription-box-confirmation">
          <i
            className="far fa-times-circle red fa-3x subscription-x"
            onClick={() => setshowActiveSubscription(false)}
          ></i>
          <div className="subscription-type-container">
            <p className="nav-logo">
              <RedLogo />
            </p>
            <h1 className="subscription-name red">
              Subscription to {firstname} {lastname}
            </h1>
          </div>
          <div className="sub-grid-three">
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i className="fas fa-user-circle mr-5 fa-lg mt-5 red"></i>
                  <p className="sub-section red">Subscription to:</p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div className="avi-color-border-alt red">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                      className="sub-avi"
                      alt="avi"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="red name-font bold">
                        {firstname} {lastname}
                      </span>
                    </li>
                    <li className="user-online-item">{jobtitle}</li>
                    <li className="user-online-item">
                      {location.city}, {location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {subscriber.role === "innovator" && (
              <div className="subscription-user">
                <div className="sub-section-container">
                  <div className="flex-only">
                    <i className="fas fa-user-circle mr-5 fa-lg mt-5 red"></i>
                    <p className="sub-section red">Subscribed user:</p>
                  </div>
                </div>
                <div className="sub-user">
                  <div className="online-avi-container">
                    <div className="avi-color-border-alt green">
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${subscriber.avatar}`}
                        className="sub-avi"
                        alt="avi-two"
                      />
                    </div>
                  </div>
                  <div className="sub-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span className="green name-font bold">
                          {subscriber.firstname} {subscriber.lastname}
                        </span>
                      </li>
                      <li className="user-online-item">
                        {subscriber.jobtitle}
                      </li>
                      <li className="user-online-item">
                        {subscriber.location.city}, {subscriber.location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
            {subscriber.role === "mentor" && (
              <div className="subscription-user">
                <div className="sub-section-container">
                  <div className="flex-only">
                    <i className="fas fa-user-circle mr-5 fa-lg mt-5 red"></i>
                    <p className="sub-section red">Subscribed user:</p>
                  </div>
                </div>
                <div className="sub-user">
                  <div className="online-avi-container">
                    <div className="avi-color-border-alt red">
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${subscriber.avatar}`}
                        className="sub-avi"
                        alt="avi-two"
                      />
                    </div>
                  </div>
                  <div className="sub-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span className="red name-font bold">
                          {subscriber.firstname} {subscriber.lastname}
                        </span>
                      </li>
                      <li className="user-online-item">
                        {subscriber.jobtitle}
                      </li>
                      <li className="user-online-item">
                        {subscriber.location.city}, {subscriber.location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
            {subscriber.role === "employer" && (
              <div className="subscription-user">
                <div className="sub-section-container">
                  <div className="flex-only">
                    <i className="fas fa-user-circle mr-5 fa-lg mt-5 red"></i>
                    <p className="sub-section red">Subscribed user:</p>
                  </div>
                </div>
                <div className="sub-user">
                  <div className="online-avi-container">
                    <div className="avi-color-border-alt blue">
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${subscriber.avatar}`}
                        className="sub-avi"
                        alt="avi-two"
                      />
                    </div>
                  </div>
                  <div className="sub-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span className="blue name-font bold">
                          {subscriber.firstname} {subscriber.lastname}
                        </span>
                      </li>
                      <li className="user-online-item">
                        {subscriber.jobtitle}
                      </li>
                      <li className="user-online-item">
                        {subscriber.location.city}, {subscriber.location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="sub-grid">
            <p className="user-request-text">
              Your subscription to {firstname} {lastname} expires in{" "}
              <span className="red bold">
                <Moment date={subscriber.expirationdate} durationFromNow />
              </span>
              .
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ActiveSubscriptionInfo;
